//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'pointList',
    data() {
        return {
            searchInput: {},
            loading: false,
            saving: false,
            columns: [
                {
                    type: 'index',
                    width: 60,
                    align: 'center'
                },
                {
                    title: '会员名',
                    key: 'name',
                    align: 'center'
                },
                {
                    title: '摘要',
                    key: 'summary',
                    align: 'center'
                },
                {
                    title: '交易积分',
                    key: 'amount',
                    width: 100,
                    render: (h, params) => {
                        const row = params.row;
                        if (row.entryType == 0) {
                            return h('span', '+' + row.amount);
                        } else if (row.entryType == 1) {
                            return h('span', '-' + row.amount);
                        }
                    },
                    align: 'center'
                },
                {
                    title: '剩余积分',
                    key: 'accountBalance',
                    align: 'center'
                },
                {
                    title: '交易时间',
                    key: 'tradeDateStr',
                    align: 'center'
                }

            ],
            cityList: []
        };
    },
    methods: {
        pageChange(page) {
            this.$store.commit('point/setCurrentPage', page);
            this.getPage();
        },
        pageSizeChange(pagesize) {
            this.$store.commit('point/setPageSize', pagesize);
            this.getPage();
        },
        async getPage() {
            this.loading = true;
            await this.$store.dispatch({
                type: 'point/getAllPointAccountDetail',
                data: this.searchInput
            }).finally(() => {
                this.loading = false;
            });
        },
        cretaeTimeChange(date) {
            this.searchInput.startTime = date[0];
            this.searchInput.endTime = date[1];
        },
        getCities() {
            this.$store.dispatch({
                type: 'city/getCityList'
            }).then(() => {
                this.cityList = this.$store.state.city.cityList;
            });
        }
    },
    computed: {
        currentPage() {
            return this.$store.state.point.currentPage;
        },
        totalCount() {
            return this.$store.state.point.totalCount;
        },
        pageSize() {
            return this.$store.state.point.pageSize;
        },
        list() {
            return this.$store.state.point.list;
        }
    },
    created() {
        this.getPage();
        this.getCities();
    }
};
